import React, { useState } from "react";
import { toast } from "react-semantic-toasts";
import { Button, TextArea, Modal, Form } from "semantic-ui-react";

import { useDispatch } from "react-redux";
import { saveOrderBuilderOrder } from "../builder/action";
import { OrderStatuses } from "../constants";

const OrderRejectionModal = ({ showModal, onRequestClose, orderId, onRejected }) => {
    const [note, setNote] = useState("");
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const rejectOrder = () => {
        setLoading(true);
        dispatch(
            saveOrderBuilderOrder({
                id: orderId,
                status: OrderStatuses.REJECTED,
                note: note,
            })
        )
            .then(order => {
                onRejected(order);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast({
                    icon: "ban",
                    type: "error",
                    title: `Error`,
                    description: `Error occurred while rejecting order.`,
                });
            });
    };

    return (
        <Modal open={showModal}>
            <Modal.Header>Reject order?</Modal.Header>
            <Modal.Content>
                <Form>
                    <p>
                        This action is irreversible, once rejected, you won't be able to invoice
                        this order. Are you sure you want to reject this order?
                    </p>
                    <TextArea
                        placeholder="Note"
                        value={note}
                        onChange={e => {
                            setNote(e.target.value);
                        }}
                    />
                </Form>
            </Modal.Content>

            <Modal.Actions>
                <Button negative content="Cancel" onClick={onRequestClose} disabled={loading} />
                <Button
                    positive
                    content="Reject"
                    onClick={rejectOrder}
                    loading={loading}
                    disabled={loading}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default OrderRejectionModal;
